export default __webpack_public_path__ + "static/media/dat.8cf5fb0b.svg";